import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  breakpoints,
  fontFamilies,
  palette,
  fontSizes,
  lineHeights,
  fontWeights,
}: Theme) => ({
  root: {
    zIndex: 1,
  },
  content: {},
  title: {
    position: 'relative',
    fontFamily: fontFamilies.primary,
    fontSize: fontSizes.lg,
    lineHeight: lineHeights.lg,
    fontWeight: fontWeights.medium,
    margin: '0 0 8px',
    [breakpoints.up('md')]: {
      fontSize: fontSizes.xxl,
      lineHeight: lineHeights.xxl,
      marginBottom: 16,
    },
  },
  titleWithoutDescription: {
    marginBottom: '2rem',
  },
  description: {
    fontFamily: fontFamilies.primary,
    fontSize: fontSizes.sm,
    lineHeight: lineHeights.lg,
    color: palette.text.primary,
    margin: '0 0 24px',
    [breakpoints.up('md')]: {
      lineHeight: lineHeights.md,
      marginBottom: 32,
    },
  },
  hintText: {
    fontFamily: fontFamilies.primary,
    fontSize: fontSizes.xxs,
    lineHeight: lineHeights.xs,
    color: palette.grey['500'],
    textAlign: 'center',
    margin: '16px 0 0',
    [breakpoints.up('md')]: {
      fontSize: fontSizes.sm,
      lineHeight: lineHeights.md,
    },
  },
  stepIndicators: {
    height: 5,
    display: 'flex',
    marginBottom: '2rem',
  },
  stepIndicator: {
    flexGrow: 1,
    marginLeft: 12,
    backgroundColor: palette.grey['200'],
    borderRadius: 10,
    '&:first-child': {
      marginLeft: 0,
    },
    [breakpoints.up('md')]: {
      marginLeft: 17,
      '&:first-child': {
        marginLeft: 0,
      },
    },
  },
  stepIndicatorDone: {
    backgroundColor: palette.primary.dark,
  },
  stepIndicatorActive: {
    backgroundColor: palette.primary.dark,
  },
  goNextButton: {
    letterSpacing: 'normal',
  },
  veeva: {
    position: 'absolute',
    left: '0.25rem',
    top: '0.25rem',
    color: palette.grey[200],
    fontSize: '0.25rem',
    lineHeight: 1.1,
  },
}));
